'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.BackgroundException = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _TraceLine = require('./TraceLine.js');

var _Exception = require('./Exception.less');

var _Exception2 = _interopRequireDefault(_Exception);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BackgroundException = exports.BackgroundException = function (_Component) {
	_inherits(BackgroundException, _Component);

	function BackgroundException() {
		var _ref;

		var _temp, _this, _ret;

		_classCallCheck(this, BackgroundException);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = BackgroundException.__proto__ || Object.getPrototypeOf(BackgroundException)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
			expanded: false
		}, _this.clickHandler = function () {
			_this.setState({
				expanded: !_this.state.expanded
			});
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	_createClass(BackgroundException, [{
		key: 'render',
		value: function render() {
			var _this2 = this;

			var traceElements;
			var jobArguments = void 0;
			if (this.state.expanded) {
				traceElements = this.props.Trace.map(function (trace, i) {
					return React.createElement(_TraceLine.TraceLine, _extends({ key: i }, trace));
				});
				if (this.props.jobArguments.substr) {
					jobArguments = this.props.jobArguments;
				} else {
					jobArguments = '{\n' + Object.keys(this.props.jobArguments).map(function (key) {
						return '\t' + key + ': ' + JSON.stringify(_this2.props.jobArguments[key]);
					}).join(',\n') + '\n}';
				}
				traceElements = React.createElement(
					'span',
					null,
					React.createElement(
						'pre',
						null,
						React.createElement(
							'span',
							{
								className: _Exception2.default.exception },
							this.props.jobClass
						),
						' ',
						jobArguments
					),
					React.createElement(
						'ol',
						{ className: _Exception2.default.trace, start: '0' },
						traceElements
					)
				);
			} else {
				traceElements = [];
			}
			return React.createElement(
				'span',
				{
					className: _Exception2.default.exceptionRow + ' ' + (this.state.expanded ? _Exception2.default.expanded : _Exception2.default.retracted),
					onClick: this.clickHandler },
				'Error while running background job\xA0',
				React.createElement(
					'span',
					{
						className: _Exception2.default.exception },
					'(',
					this.props.Exception,
					')'
				),
				':',
				React.createElement(
					'span',
					{ className: _Exception2.default.messsage },
					' ',
					this.props.Message
				),
				traceElements
			);
		}
	}]);

	return BackgroundException;
}(_react.Component);


//////////////////
// WEBPACK FOOTER
// ./js/Components/BackgroundException.js
// module id = 650
// module chunks = 0